/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './AddWms.scss';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';

import ModalAlert from '../../../ModalAlert';
import { deleteExternalLayer, addExternalLayer } from '../../../../../actions/district';

const ModalConfirm = (props) => {
  return (
    <Modal {...props} >
      <Modal.Header className="bg-warning" closeButton>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.bodyText}
        <br /><br />
        <Button className="btn btn-default pull-right" onClick={props.onHide}>Anuluj</Button>
        <Button className="btn btn-warning pull-right" onClick={props.confirm}>OK</Button>
        <br /><br />
      </Modal.Body>
    </Modal>
  );
};

const fastStyleMargin = {
  marginTop: '7px',
};

const fullWidth = {
  width: '100% !important',
}

class AddWms extends React.Component {
  constructor(props) {
    super(props);
    const startService = 'WMS';
    this.state = {
      showModal: false,
      showConfirm: false,
      modalTitle: '',
      modalBody: '',
      nazwa: '',
      adress: '',
      serviceType: startService,
      versions: {
        WMS: ['1.3.0', '1.1.1', '1.1.0', '1.0'],
        WMTS: ['1.1.0', '1.0'],
      },
      warstwa: '',
      selectedVersion: '1.3.0',
    };
  }

  onChangeAdress = (e) => this.setState({ adress: e.target.value });
  onChangeNazwa= (e) => this.setState({ nazwa: e.target.value });
  onChangeWarstwa = (e) => this.setState({ warstwa: e.target.value });
  onChangeServiceType = (e) => this.setState({ serviceType: e.target.value });
  onChangeVersion = (e) => this.setState({ selectedVersion: e.target.value });


  onConfirm = () => {
    this.dismissConfirm();
    this.props.addExternalLayer(
                                this.props.district.prefix,
                                this.state.nazwa,
                                this.state.adress,
                                this.state.serviceType,
                                this.state.warstwa,
                                this.state.selectedVersion)
    .then((response) => {
      if (response.status === 200) {
        this.setState({ modalTitle: 'Status', modalBody: 'Pomyślnie dodano warstwę zewnęrzną.', showModal: true });
      } else {
        this.setState({ modalTitle: 'Status', modalBody: response.message, showModal: true });
      }
    });
  }
  getWmsData = () => {
    let adres = this.state.adress.slice(0, this.state.adress.slice(0, this.state.adress.indexOf('&')).indexOf('?'));
    adres = adres + this.state.adress + '?service=' + this.state.serviceType + '&version=' + this.state.selectedVersion + '&request=GetCapabilities';
  };
  dismissModal = () => this.setState({ showModal: false });
  dismissConfirm = () => this.setState({ showConfirm: false });

  add = () => {
    if (!this.state.adress || !this.state.warstwa || !this.state.nazwa) {
      this.setState({ modalTitle: 'Błąd', modalBody: 'Wypełnij pola formularza', showModal: true });
    } else {
      this.setState({ showConfirm: true, modalTitle: 'Potwierdzenie', modalBody: 'Czy wypełnione dane są poprawne ? Nieprawidłowe wypełnienie pól tego formularza może skutkować wywietlaniem pustych kafli' });
    }
  }



  delete = (nazwa) => {
    this.props.deleteExternalLayer(this.props.district.prefix, nazwa)
    .then((response) => {
      if (response.status === 200) {
        this.setState({ modalTitle: 'Status', modalBody: 'Pomyślnie usunięto warstwę zewnęrzną.', showModal: true });
      } else {
        this.setState({ modalTitle: 'Status', modalBody: response.message, showModal: true });
      }
    });
  }

  render() {
    return (
      <div className="col-xs-12">
        <div className="row">
          <label htmlFor="nazwa" className="col-xs-3" style={fastStyleMargin}>Nazwa</label>
          <input name="nazwa" type="text" className="adresInput" value={this.state.nazwa} onChange={(e) => this.onChangeNazwa(e)} />
        </div>
        <div className="row">
          <label htmlFor="adres" className="col-xs-3" style={fastStyleMargin}>Adres</label>
          <input name="adres" type="text" className="adresInput" value={this.state.adress} onChange={(e) => this.onChangeAdress(e)} />
        </div>
        <div className="row" style={fastStyleMargin}>
          <label htmlFor="warstwa" className="col-xs-3" style={fastStyleMargin}>Warstwa</label>
          <input name="warstwa" type="text" className="adresInput" value={this.state.warstwa} onChange={(e) => this.onChangeWarstwa(e)} />
        </div>
        <div className="row" style={fastStyleMargin}>
          <div className="form-inline">
            <label className="col-xs-3" style={fastStyleMargin} htmlFor="serviceType">Typ usługi</label>
            <select className="form-control col-xs-9" value={this.state.serviceType} onChange={(e) => this.onChangeServiceType(e)}>
              <option>WMS</option>
              <option>WMTS</option>
            </select>
          </div>
        </div>
        <div className="row" style={fastStyleMargin}>
          <div className="form-inline">
            <label className="col-xs-3" style={fastStyleMargin} htmlFor="serviceType">Wersja usługi</label>
            <select className="form-control col-xs-9" value={this.state.selectedVersion} onChange={(e) => this.onChangeVersion(e)}>
              {this.state.versions[this.state.serviceType].map((v, i) => <option key={i} value={v}>{v}</option>)}
            </select>
          </div>
        </div>
        <div className="row" style={fastStyleMargin}>
          {/*<button type="button" className="btn btn-info" onClick={() => this.getWmsData()}>Pobierz</button>*/}
          <button type="button" className="btn btn-info" onClick={() => this.add()}>Dodaj</button>
        </div>
        <ModalAlert
          title={this.state.modalTitle}
          bodyText={this.state.modalBody}
          show={this.state.showModal}
          onHide={this.dismissModal}
        />
        <ModalConfirm
          title={this.state.modalTitle}
          bodyText={this.state.modalBody}
          show={this.state.showConfirm}
          confirm={this.onConfirm}
          onHide={this.dismissConfirm}
        />

        <div className="row">
          <br /> <br />

          <h4> Lista warstw zewnętrznych: </h4>
          <table className="table layers-table">
              {this.props.district.externalLayers && this.props.district.externalLayers.map((v, i) => {
                return (
                  <tr key={i} className="main-table-row">

                    <tr>
                      <td><span className="tr-label">Nazwa: </span></td>
                      <td className="tr-content">{v.nazwa}</td>
                    </tr>
                    <tr>
                      <td><span className="tr-label">Adres: </span></td>
                      <td className="tr-content">{v.adres}</td>
                    </tr>
                    <tr>
                      <td><span className="tr-label">Typ: </span></td>
                      <td className="tr-content">{v.typ}</td>
                    </tr>
                    <tr>
                      <td><span className="tr-label">Warstwa: </span></td>
                      <td className="tr-content">{v.warstwa}</td>
                    </tr>
                    <tr>
                      <td><span className="tr-label">Wersja: </span></td>
                      <td className="tr-content">{v.wersja}</td>
                    </tr>


                    <tr>
                      <td><span className="tr-label">Działania: </span></td>
                      <td className="tr-content">
                        <button type="button" className="btn btn-danger" onClick={() => this.delete(v.nazwa)}>Usuń</button>
                      </td>
                    </tr>
                  </tr>)
              })}

          </table>
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  district: state.district.district,
});
const mapDispatch = {
  deleteExternalLayer,
  addExternalLayer,
};

export default withStyles(s)(connect(mapState, mapDispatch)(AddWms));



// WEBPACK FOOTER //
// src/components/Modals/Settings/Panels/AddWms/AddWms.js